// extracted by mini-css-extract-plugin
module.exports = {"NoButton":"ModalPopup_NoButton__cREC7","Button":"ModalPopup_Button__1UYZl","modalBody":"ModalPopup_modalBody__2dwcE","modalContent":"ModalPopup_modalContent__2Oe9s"};